<template>
  <v-overlay :value="loading">
    <div class="text-center">
      <v-progress-circular
      v-if="loading"
        :rotate="-90"
        :size="100"
        :width="15"
        :value="progressPercentage"
        color="primary"
      >
        {{ progressPercentage }}%
      </v-progress-circular>

      <v-alert v-if="isThereAnError" type="error">
        There was an error while importing data.
      </v-alert>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'percentageLoader',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    totalRecords: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isThereAnError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    progressPercentage() {
      let percentage = (this.value / this.totalRecords) * 100;
      if (!percentage || Number.isNaN(percentage)) percentage = 0;
      return Math.round(percentage);
    },
  },
};
</script>

<style>
.v-progress-circular {
  margin: 1rem;
}
</style>
